<template>
    <!-- 带导航标签的父页面 -->
    <div>
        <router-view />

        <div class="main-nav-wrap">
            <van-tabbar class="main-nav-bar" v-model="active" route>
                <van-tabbar-item icon="wap-home-o" to="/main">首页</van-tabbar-item>
                <van-tabbar-item icon="apps-o" to="/column">栏目</van-tabbar-item>
                <van-tabbar-item icon="medal-o" to="/activity">活动</van-tabbar-item>
                <van-tabbar-item icon="manager-o" to="/my">我的</van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>

<script>
export default {
    name: "mainNav",
    data() {
        return {
            active: 0,
        };
    },
}
</script>

<style scoped>
.main-nav-bar{
    border-top: 1px solid rgba(0,0,0,0.1);
}
</style>
